var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"show_report_50bang":_vm.pageAdInfo.show_report_50bang,"uid":_vm.pageAdInfo.uid,"compName":_vm.compName,"tag":_vm.tag}},[_c('div',{attrs:{"id":_vm.pageAdInfo.divId}})])}
var staticRenderFns = []

export { render, staticRenderFns }